var acc = document.querySelectorAll(".accordion-faq");
  var i;
  
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function(ee) {
      
      let allFaqValue = document.querySelectorAll(".panel-faq");
      if (this.nextElementSibling.style.maxHeight == this.nextElementSibling.scrollHeight + 'px') {
        // this.nextElementSibling.style.display = "none";
        this.nextElementSibling.style.maxHeight = 0;
        acc.forEach(elem => {
        elem.classList.remove("faq-active");
      });
      } else {
        allFaqValue.forEach(elem => {
          // elem.style.display = "none";
          elem.style.maxHeight = 0;
        });

      acc.forEach(elem => {
        elem.classList.remove("faq-active");
      });
        this.classList.add("faq-active");
        
        // this.nextElementSibling.style.display = "block";
        this.nextElementSibling.style.maxHeight = this.nextElementSibling.scrollHeight + 'px';
      }
      
    });
  }




  /*main faq page*/


  $(document).ready(function() {
    $('a[href*=#]').bind('click', function(e) {
            e.preventDefault(); // prevent hard jump, the default behavior

            var target = $(this).attr("href"); // Set the target as variable

            // perform animated scrolling by getting top-position of target-element and set it as scroll target
            $('html, body').stop().animate({
                    scrollTop: $(target).offset().top
            }, 600, function() {
                    location.hash = target; //attach the hash (#jumptarget) to the pageurl
            });

            return false;
    });
});

let $root = $('html, body');
$('a[href^="#"]').click(function() {
    let href = $.attr(this, 'href');
    $root.animate({
      scrollTop: $(href).offset().top
    }, 500, function() {
      window.location.hash = href;
    });
    return false;
  });

  // metafield variant

  const prdVarEl = document.querySelectorAll('.variant-input-wrap[data-index="option1"] .variant-input');
  const varMeta = document.querySelectorAll(".custom_variant_description .metafield-rich_text_field");

  if (varMeta[0]) {
    for (let i = 0; i < prdVarEl.length; i++) {

      prdVarEl[i].setAttribute("cus_index",i);
      if (prdVarEl[i].querySelector("input").checked) {
        let cusIndex = prdVarEl[i].getAttribute("cus_index");
        if (varMeta[cusIndex]) {
          varMeta[cusIndex].classList.add("show_cus_meta");
        }
      }

      prdVarEl[i].addEventListener("click",function(){
        if (document.querySelector(".show_cus_meta")) {
          document.querySelector(".show_cus_meta").classList.remove("show_cus_meta");
        }
        cusIndex = this.getAttribute("cus_index");
        if (varMeta[cusIndex]) {
          varMeta[cusIndex].classList.add("show_cus_meta");
        } 
      })

    }
  }



// >>>>>>>>>>>>>>>>>>>>>product page variant images show or hide>>>>>>>>>>>>>>>>>


$(document).ready(function() {

  let variantval  = $('input:radio[name=Leaps]:checked').val();
  if (document.querySelector(`.slick-track .mw_${variantval}`)) {
    
    $(".slick-track .product__thumb-item").hide();
    $(".slick-track").find('.mw_'+ variantval ).show(); 

    $(".variant-input").click(function(){
      let variantval = $(this).attr("data-value");
      $(".slick-track .product__thumb-item").hide();
      $(".slick-track").find('.mw_'+ variantval ).show(); 
    });

  }

});






